module.exports = __webpack_public_path__ + "80c976c7863d71d561fc81a5a81ef229.png";